import {useState} from 'react';
import useApi from '../../../utils/custom-hooks/api-hooks/useApi';

const useFetchPdfEstimate = () => {
    const {get} = useApi();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);


    const ENDPOINT = process.env.REACT_APP_ENDPOINT;
    const access_token = localStorage.getItem('@access_token');

    const fetchPdf = async (pk: number | undefined) => {
        setLoading(true);
        setError(null);

        const url = ENDPOINT + `/estimates/${pk}/get_pdf?token=${access_token}`;

        try {
            const newWindow = window.open(url, '_blank');
        } catch (e) {
        }
    };

    return {fetchPdf, loading, error};
};

export default useFetchPdfEstimate;
